module.exports = __webpack_public_path__ + "src/images/products/trendsetter/100_Olive Seersucker Shirt Jacket.png";